import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EmployeePermissionService from "../services/EmployeePermissionService";
import StorageService from "../services/StorageService";
import utility from "./utility";   //  because same utils folder

const usePermission = (screenId, showMessage) => {
  const [permission, setPermission] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadPermission = async () => {
      try {
        const login = StorageService.loginData();

        const perm =
          await EmployeePermissionService.getPermissionsByUserScreen(
            login.employeeId,
            screenId
          );

        setPermission(
          perm || {
            canView: 0,
            canAdd: 0,
            canModify: 0,
            canCancel: 0,
            canApprove: 0,
            canReject: 0,
            canTransfer: 0,
            canEsclate: 0,
            allowNotification: 0,
          }
        );
      } catch (err) {
        console.error("Permission load error:", err);
      }
    };

    loadPermission();
  }, [screenId]);

  //  VIEW CHECK
  const checkView = () => {
    if (
      permission &&
      !utility.checkViewPermission(permission, showMessage, navigate)
    ) {
      return false;
    }
    return true;
  };

  //  BUTTON / ACTION CHECK
  const can = (action) => {
    return utility.hasPermission(permission, action);
  };

  return {
    permission,
    checkView,
    can,
  };
};

export default usePermission;